import { useEffect } from 'react'
import { useHookstate } from '@hookstate/core'
import { NotificationsGlobalState } from './notifications-global-state'
import { getMessagingToken, onMessageListener } from '../../../services/firebase/firebaseMessaging'
import { setNotificationsUseCase } from '../../application/set-messaging-token.use-case'
import { odinNotificationsRepository } from '../odin-notifications.reposiroty'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

type NotificationsProps = {
  user: any
}
const Notifications = ({ user }: NotificationsProps) => {
  const { t } = useTranslation()
  const { messages } = useHookstate(NotificationsGlobalState)

  const setNotificationsUseCaseInteractor = setNotificationsUseCase(odinNotificationsRepository)

  const getNotificationPermission = async (): Promise<void> => {
    if (!user.id) return
    if (!('Notification' in window) || !('serviceWorker' in window.navigator)) {
      message.error(t('notifications.unsupported'))
      return
    }
    let permission = Notification.permission
    let token: string = ''

    if (user.id && !user.messagingToken && permission === 'default') {
      permission = await Notification.requestPermission()
      if (permission === 'granted') {
        token = await getMessagingToken()
      }
    } else if (user.id && permission === 'granted') {
      token = await getMessagingToken()
    }

    if (permission === 'denied') {
      message.error(t('notifications.denied'))
      return
    }
    if (permission !== 'granted') {
      return
    }
    if (token) {
      await setNotificationsUseCaseInteractor(token)
      onMessageListener((payload: any) => {
        messages.set([...messages.get({ noproxy: true }), { jobId: payload.jobId, count: 1 }])
      })
    }
  }

  useEffect(() => {
    getNotificationPermission()
  }, [])

  return null
}

export { Notifications }
